import axios from "axios";
import { API_BASE, isSessionToken, resolveApiUrl } from "../api/base";

function sanitizeHeaders(headers = {}) {
  const nextHeaders = { ...headers };
  const authValue = nextHeaders.Authorization || nextHeaders.authorization;

  if (
    !authValue ||
    /Bearer\s+(undefined|null)?$/i.test(String(authValue).trim()) ||
    isSessionToken(String(authValue).replace(/^Bearer\s+/i, "").trim())
  ) {
    delete nextHeaders.Authorization;
    delete nextHeaders.authorization;
  }

  return nextHeaders;
}

export function initializeHttpClients() {
  if (typeof window !== "undefined") {
    window.__SBIN_API_BASE__ = API_BASE;
  }

  axios.defaults.withCredentials = true;
  axios.interceptors.request.use((config) => {
    const nextConfig = { ...config };
    if (nextConfig.url) {
      nextConfig.url = resolveApiUrl(nextConfig.url);
    }
    nextConfig.withCredentials = true;
    nextConfig.headers = sanitizeHeaders(nextConfig.headers || {});
    return nextConfig;
  });

  if (typeof window === "undefined" || typeof window.fetch !== "function") {
    return;
  }

  const originalFetch = window.fetch.bind(window);
  window.fetch = (input, init = {}) => {
    const requestUrl =
      typeof input === "string" ? resolveApiUrl(input) : input instanceof URL ? resolveApiUrl(input.toString()) : input;

    const nextInit = {
      ...init,
      credentials: init.credentials || "include",
      headers: sanitizeHeaders(init.headers || {}),
    };

    return originalFetch(requestUrl, nextInit);
  };
}
